import {Component} from '@angular/core';
import {Fluid} from "primeng/fluid";
import {AsyncPipe, NgForOf} from '@angular/common';
import {Card} from 'primeng/card';
import {Select} from 'primeng/select';
import {Observable} from 'rxjs';
import {ManufacturerCollection} from '../../manufacturer/manufacturer-collection';
import {Manufacturer} from '../../manufacturer/manufacturer';
import {ManufacturerService} from '../../manufacturer/manufacturer.service';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {CustomFieldService} from '../../custom-field/custom-field.service';
import {InputText} from 'primeng/inputtext';
import {Button} from 'primeng/button';
import {IconComponent} from '../../components/app/layout/icon/icon.component';
import {CustomField} from '../../custom-field/custom-field';

@Component({
  selector: 'app-custom-fields',
    imports: [
        Fluid,
        AsyncPipe,
        Card,
        Select,
        FormsModule,
        NgForOf,
        InputText,
        ReactiveFormsModule,
        Button,
        IconComponent
    ],
  templateUrl: './custom-fields.html',
  styleUrl: './custom-fields.scss',
})
export class CustomFields {

    protected manufacturers$!: Observable<ManufacturerCollection>;
    protected selectedManufacturer: Manufacturer | null = null;
    protected customFields: CustomField[] = [];

    constructor(
        private manufacturerService: ManufacturerService,
        private customFieldService: CustomFieldService,
    ) {
    }

    ngOnInit() {
        this.manufacturers$ = this.manufacturerService.getAll();
    }

    protected addNewCustomField(customFieldName: string): void {
        if (this.selectedManufacturer) {
            this.customFieldService
                .createCustomField(this.selectedManufacturer, customFieldName)
                .subscribe(newCustomField => {
                    this.customFields.push(newCustomField);
                });
        }
    }

    protected manufacturerChanged(): void {
        if (this.selectedManufacturer) {
            this.customFieldService.loadCustomFields(this.selectedManufacturer).subscribe(customFieldsCollection => {
                this.customFields = customFieldsCollection.getCustomFields();
            })
        } else {
            this.customFields = [];
        }
    }
}
